import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { StaticImage } from 'gatsby-plugin-image'
import ContentfulButtonV3 from '../Buttons/V3/ContentfulButtonV3'
import Headline from '../../Headline/Headline'
import useIsHydrated from '../../Hooks/useIsHydrated'

const ROW_TEMPLATE_ID = '53aa8912dec7e10d38f59f36'
const ROW_HEIGHT = 140
const GRID_TEMPLATE_ID = '539adbd6dec7e10e686debee'

function TrustPilot({ data: { dataTags, layout, gridHeight, button, trustPilotHeadline } }) {
  const trustPilotRef = useRef(null)
  const isHydrated = useIsHydrated()

  useEffect(() => {
    if (window.Trustpilot && trustPilotRef.current && trustPilotRef.current) {
      window.Trustpilot.loadFromElement(trustPilotRef.current)
    }
  })

  const attr = {}
  if (dataTags && dataTags.length && dataTags[0] !== 'None') {
    attr['data-tags'] = dataTags
  }

  const isGridLayout = layout === 'Grid'
  const templateId = isGridLayout ? GRID_TEMPLATE_ID : ROW_TEMPLATE_ID
  const styleHeight = isGridLayout ? gridHeight : ROW_HEIGHT

  if (!isHydrated) return null

  /* eslint-disable react/jsx-props-no-spreading */
  return (
    <div className="trustpilot-outer-wrapper">
      <div className="inner-wrapper">
        &nbsp;
        <StaticImage
          src="../../../assets/images/trustpilot/tp-background.png"
          className="trustpilot-decoration background-img"
          alt="Diagonal Lines Decoration"
          width={958}
        />
        <div id="trusted-widget-wrapper">
          {trustPilotHeadline ? <Headline data={trustPilotHeadline} /> : null}
          <div
            className="trustpilot-widget"
            data-locale="en-US"
            data-template-id={templateId}
            data-businessunit-id="551cfda10000ff00057e75b0"
            data-style-height={`${styleHeight}px`}
            data-style-width="100%"
            data-testid="trustpilot-widget"
            data-theme="light"
            {...attr}
            data-stars="4,5"
            ref={trustPilotRef}
          >
            <a
              href="https://www.trustpilot.com/review/avant.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              TrustPilot
            </a>
          </div>
          {button ? (
            <ContentfulButtonV3
              style={button.style}
              dataEvent={button.dataEvent}
              pageCategory={button.pageCategory}
              data={button}
            />
          ) : null}
          <br />
          <div className="trustpilot-testimonial">
            <p>
              ◊ Testimonials reflect the individual&apos;s opinion and may not be illustrative of
              all individual experiences with Avant.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

TrustPilot.defaultProps = {
  data: {}
}

TrustPilot.propTypes = {
  data: PropTypes.object
}

export { query as data } from './trustPilotQuery'

export default TrustPilot
